/* eslint-disable react/require-default-props */
import { Grid, IconButton, makeStyles, } from '@material-ui/core';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import React from 'react';
const useStyles = makeStyles(() => ({
    button: {
        position: 'relative',
        '&:before': {
            content: "''",
            position: 'absolute',
            top: '-5px',
            left: '-5px',
            bottom: '-5px',
            right: '-5px',
            zIndex: 2,
        },
    },
}));
const BackButton = ({ onBack, className = '' }) => {
    const classes = useStyles();
    return (React.createElement(Grid, { item: true, className: className },
        React.createElement(IconButton, { className: classes.button, color: 'primary', onClick: onBack },
            React.createElement(KeyboardBackspaceIcon, null))));
};
export default BackButton;
